module.exports = __webpack_public_path__ + "static/media/home-background-lithographie.977ff1ea.png";